"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocalItem = exports.getSessionItem = void 0;

var getSessionItem = function getSessionItem(item) {
  var sessionItemVal = typeof sessionStorage !== "undefined" && sessionStorage.getItem(item);

  if (sessionItemVal !== null) {
    return sessionItemVal;
  } else {
    return undefined;
  }
};

exports.getSessionItem = getSessionItem;

var getLocalItem = function getLocalItem(item) {
  var storageItem = typeof localStorage !== "undefined" && localStorage.getItem(item);

  if (storageItem !== null) {
    return storageItem;
  } else {
    return undefined;
  }
};

exports.getLocalItem = getLocalItem;
var SessionUtilities = {
  getSessionItem: exports.getSessionItem,
  getLocalItem: exports.getLocalItem
};
exports.default = SessionUtilities;